module.exports = __webpack_public_path__ + "static/media/icon_check.d9e84b95.svg";